export function getXsrfToken(): string | null {
  const match = document.cookie.match(
    new RegExp("(^|;\\s*)XSRF-TOKEN=([^;]*)"),
  );
  return match ? decodeURIComponent(match[2]) : null;
}
